// frontend/src/pages/Solutions/Energy.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import energyHero from "./img/enegry1.webp";
import { ensureNamespace } from "../../i18n/ensurePageI18n";

const loadI18n = (i18n) => {
  ensureNamespace(i18n, 'energy', {
    en: {
      sectionTitle: "Solar Energy",
      sectionSubtitle: "Optical Vision Systems for Solar Module Materials",
      title: "SOLAR ENERGY",
      heroDesc: "Wintriss Engineering industrial optical vision systems detect defects in many of the component materials used in solar module manufacture.",
      typicalProductsTitle: "Typical Products",
      typicalProductsContent: "Back sheet, PVDF fluoropolymer film, EVA film, glass.",
      typicalDefectsTitle: "Typical Defects",
      typicalDefectsContent: "Black spots, yellow spots, contaminants, air bubbles, bumps, creases, dents, scratches, adhesive residues, bugs, and more."
    },
    zh: {
      sectionTitle: "太陽能",
      sectionSubtitle: "太陽能模組材料光學視覺檢測系統",
      title: "太陽能",
      heroDesc: "微覺視工業光學視覺系統可檢測太陽能模組製造中多種組件材料的缺陷。",
      typicalProductsTitle: "典型產品",
      typicalProductsContent: "背板、PVDF 氟聚合物膜、EVA 膜、玻璃。",
      typicalDefectsTitle: "常見缺陷",
      typicalDefectsContent: "黑點、黃斑、異物、氣泡、凸起、摺痕、凹痕、刮傷、膠殘留、蟲斑等。"
    }
  });
};

function Energy() {
  const { t, i18n } = useTranslation();
  loadI18n(i18n);

  return (
    <div>
      <section className="section-energy relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10 flex justify-between items-start">
          <div>
            <h1 className="text-5xl font-bold mb-4">{t("energy:sectionTitle")}</h1>
            <p className="text-xl text-white">{t("energy:sectionSubtitle")}</p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">{t("energy:title")}</h2>
          <p className="leading-relaxed text-sm md:text-base">{t("energy:heroDesc")}</p>
        </div>
        <div className="flex justify-center">
          <img src={energyHero} alt={t("energy:title")} className="rounded-lg shadow-lg w-full max-w-md object-cover" loading="lazy" />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-20 grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("energy:typicalProductsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("energy:typicalProductsContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("energy:typicalDefectsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("energy:typicalDefectsContent")}</p>
        </div>
      </section>
    </div>
  );
}

export default Energy;